module.exports = ".logo {\n  position: absolute;\n  top: 0;\n  z-index: 3;\n  background-color: green;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.css
// module id = ./src/app/components/home/home.component.css
// module chunks = main